import { SongListType } from '../../../../common/src/model.ts';
import { Calendar } from './org/calendar.tsx';

export function SeasonalCalendar() {
  return <Calendar songListType={SongListType.Seasonal} />;
}
